import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  viewChild
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import {
  GetScheduledMessageByIdDto,
  SendTypes,
  UseTypes,
} from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { PhonebookSelectorComponent } from 'src/app/pages/facility/phonebook/phonebook-selector/phonebook-selector.component';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { UpdateDynamicScheduledMessageCommand } from './../../../../core/api/models/update-dynamic-scheduled-message-command';
import { ScheduledMessagesService } from './../../../../core/api/services/scheduled-messages.service';
import { DateTimeConfig } from './../../../../shared/components/date-time-picker/date-time-picker.component';

@Component({
    selector: 'app-edit-dynamic-send-sms',
    templateUrl: './edit-dynamic-send-sms.component.html',
    styleUrls: ['./edit-dynamic-send-sms.component.scss'],
    standalone: false
})
export class EditDynamicSendSmsComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties
  readonly phonebookSelectorComponent = viewChild(PhonebookSelectorComponent);

  @Input() dynamicData: GetScheduledMessageByIdDto;

  model: UpdateDynamicScheduledMessageCommand = {};
  directDateTimeConfig: DateTimeConfig;
  get SendTypes() {
    return SendTypes;
  }
  get UseTypes() {
    return UseTypes;
  }
  isCanSendFlashSms: boolean = false;

  //#endregion

  constructor(protected currentService: ScheduledMessagesService) {
    super();
  }

  ngOnInit() {
    try {
      ConsoleService.info('editDATA', this.formPageConfig);
      this.model = Object.assign({}, this.dynamicData);

      this.initForm();
      this.formPageConfig.title = 'pages.dynamicSendSms.form.editTitle';
      this.configBaseSendSMS();
      ConsoleService.info('model', this.model);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.dynamicData && this.dynamicData.phonebookRecipients?.length) {
      this.dynamicData.phonebookRecipients =
        this.dynamicData.phonebookRecipients.map((p) => ({
          checked: true,
          isValid: true,
          id: p.phonebookId,
          name: p.phonebookName,
          contactsCount: p.contactCount,
          fromIndex: p.fromIndex,
          count: p.count,
        }));
    }
  }

  ngAfterViewInit(): void {
    //edit mode
    const phonebookSelectorComponent = this.phonebookSelectorComponent();
    if (
      phonebookSelectorComponent &&
      this.dynamicData.phonebookRecipients?.length
    ) {
      phonebookSelectorComponent.phonebookRecipients =
        this.dynamicData.phonebookRecipients;
      phonebookSelectorComponent.applyPhonebookRecipients();
    }
  }

  initForm() {
    this.form = new FormGroup({
      senderNumberId: new FormControl('', Validators.required),
      sendDate: new FormControl('', Validators.required),
      sendTime: new FormControl('', Validators.required),
      description: new FormControl(''),
      isFlashSms: new FormControl(''),
    });
  }
  configBaseSendSMS() {
    try {
      this.directDateTimeConfig = {
        dateLabel: 'common.sendDay',
        timeLabel: 'common.sendHour',
        dateFormControl: this.form?.get('sendDate') as FormControl,
        timeFormControl: this.form?.get('sendTime') as FormControl,
        responsiveClassName: 'tw-w-full',
        minDateType: 'today',
        dateTimeValue: this.model.dateTimeNext,
        isEditMode: this.formPageConfig.isEditMode,
      };
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  //#region Api

  //Update
  baseUpdateApi(model: UpdateDynamicScheduledMessageCommand) {
    this.unSubs();
    this.loading = true;
    this.currentService
      .scheduledMessagesUpdateDynamicScheduledMessagePut({
        body: this.model,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;
      this.baseUpdateApi(this.model);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  changeRecipients(recipients) {
    this.model.phonebookRecipients = recipients;
  }
}
